const Vue = require('vue')

Vue.component('form-selection-item', {
    props: {
        identifier: {
            required: true
        },
        store: {
            type: Vue,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            checked: false,
            visible: true
        }
    },
    attached () {
        this.store.$on('unchecked', this.onUnchecked)

        this.store.$on('unchecked-many', this.onUncheckedMany)

        this.store.$on('checked', this.onChecked)

        this.store.$on('checked-many', this.onCheckedMany)

        this.store.$on('uncheck', this.onUncheck)

        this.store.$on('check', this.onCheck)

        this.store.$on('check-if-visible', this.onCheckIfVisible)

        this.store.$on('uncheck-if-visible', this.onUncheckIfVisible)

        this.store.$on('toggle-if-visible', this.onToggleIfVisible)

        this.store.$on('reset', this.onReset)

        this.visible = true
    },
    detached () {
        this.store.$off('unchecked', this.onUnchecked)

        this.store.$off('checked', this.onChecked)

        this.store.$off('uncheck', this.onUncheck)

        this.store.$off('check', this.onCheck)

        this.store.$off('check-if-visible', this.onCheckIfVisible)

        this.store.$off('uncheck-if-visible', this.onUncheckIfVisible)

        this.store.$off('toggle-if-visible', this.onToggleIfVisible)

        this.store.$off('reset', this.onReset)

        this.visible = false

        this.store.deregister(this.identifier)
    },
    beforeDestroy () {
        this.store.$off('unchecked', this.onUnchecked)

        this.store.$off('checked', this.onChecked)

        this.store.$off('uncheck', this.onUncheck)

        this.store.$off('check', this.onCheck)

        this.store.$off('check-if-visible', this.onCheckIfVisible)

        this.store.$off('uncheck-if-visible', this.onUncheckIfVisible)

        this.store.$off('toggle-if-visible', this.onToggleIfVisible)

        this.store.$off('reset', this.onReset)

        this.visible = false

        this.store.deregister(this.identifier)
    },
    ready () {
        if (!this.disabled) {
            this.store.register(this.identifier)
        } else {
            this.store.deregister(this.identifier)
        }

        this.checked = this.store.has(this.identifier)
    },
    methods: {
        changed (value) {
            if (this.disabled) return

            if (value) {
                this.store.check(this.identifier)
            } else {
                this.store.uncheck(this.identifier)
            }
        },
        onUnchecked (id) {
            if (this.identifier === id) {
                this.checked = false
            }
        },
        onUncheckedMany (ids) {
            if (ids.indexOf(this.identifier) > -1) {
                this.checked = false
            }
        },
        onChecked (id) {
            if (this.identifier === id) {
                this.checked = true
            }
        },
        onCheckedMany (ids) {
            if (ids.indexOf(this.identifier) > -1) {
                this.checked = true
            }
        },
        onUncheck () {
            this.checked = false
        },
        onCheck () {
            this.checked = true
        },
        onCheckIfVisible () {
            if (this.disabled) return

            this.store.check(this.identifier)
        },
        onUncheckIfVisible () {
            if (this.disabled) return

            this.store.uncheck(this.identifier)
        },
        onToggleIfVisible () {
            if (this.disabled) return

            if (this.checked) {
                this.store.uncheck(this.identifier)
            } else {
                this.store.check(this.identifier)
            }
        },
        onReset () {
            this.store.uncheck(this.identifier)
        }
    },
    watch: {
        disabled () {
            if (this.disabled) {
                this.store.register(this.identifier)
            } else {
                this.store.deregister(this.identifier)
            }
        }
    },
    template: `
<div class="form-selection-item">
    <form-check :on-change="changed" :model.sync="checked" :disabled="disabled"></form-check>
</div>
`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/selection-item.js